// extracted by mini-css-extract-plugin
export default {"container":"style_container__Fcwba","card":"style_card__zBjEY"};